import axios from '../../shared/axiosConfig';
import * as CompanyActions from './Company';
import { push } from 'connected-react-router'

import config from '../../shared/config';

export const QuestionsActions = {
  SET_ATTRIBUTE: "QUESTIONS_SET_ATTRIBUTE",
  SET_ANSWER: "QUESTIONS_SET_ANSWER"
};

/**
 * @param {String} key
 * @param {*} value
 */
export const setQuestionsAttribute = (key, value) => {
  return {
    type: QuestionsActions.SET_ATTRIBUTE,
    key,
    value
  };
};

export const setAnswer = (key, value) => {
  return {
    type: QuestionsActions.SET_ANSWER,
    key,
    value
  }
}

export const setInProgress = (state) => setQuestionsAttribute('inProgress', state);
export const setError = (error) => setQuestionsAttribute('error', error);

export const closeDialog = () => {
  return setQuestionsAttribute('open', false);
}

export const openDialog = () => {
  return setQuestionsAttribute('open', true);
}

export const recordAnswer = (key, value) => (dispatch, getState) => {
  dispatch( setAnswer(key, value) );
  dispatch( checkCompleteness() );
}

export const checkCompleteness = () => (dispatch, getState) => {
  let questions = getState().company.questions;
  let answers = getState().questions.answers;
  let result = true;
  for(let i in questions) {
    result = result && answers[questions[i].id];
  }
  dispatch( setQuestionsAttribute('completed', result) );
}

export const fetchAnswers = () => async (dispatch) => {
  console.log("Getting jobseeker profile");
  dispatch( setLoaded(false) );
  await axios.get('/api/jobseeker')
    .then( (res) => {
      console.log("Received profile", res.data);
      dispatch( setQuestionsAttribute('data', res.data) );
      dispatch( setLoaded(true) );
    })
    .catch( function(err) {
      console.log(err);
      dispatch( setError(err) );
    });
}

export const submitAnswers = () => async (dispatch, getState) => {
  let completed = getState().questions.completed;
  let data = { answers: getState().questions.answers };
  let {eventId, companyId} = getState().company;

  console.log("Sumbitting jobseeker answers", data);
  dispatch( setInProgress(true) );
  await axios.post(`/api/events/${eventId}/companies/${companyId}/answers`, data)
    .then( async (res) => {
      console.log("Sent answers, received: ", res.data );
      dispatch( setQuestionsAttribute('passed', res.data.passed ) );
      if( res.data.passed ) {
        // redirect to chat
        dispatch( closeDialog() );
        dispatch( CompanyActions.setCompanyAttribute('loaded', false));
        dispatch( CompanyActions.redirectToChat() );
      }else {
        dispatch( setQuestionsAttribute('failed', true ) );
      }
      dispatch( setInProgress(false) );
    })
    .catch( function(err) {
      console.log(err);
      dispatch( setInProgress(false) );
      dispatch( setError(err) );
    });
}
